import { hubspotConfig } from '@api/auth/config';
import { useEffect } from 'react';
import { useAuth } from '@hooks/useAuth';
import { useLocation } from '@tanstack/react-router';
import { useAppContext } from '@context/AppContext';
import { CHAT_BUTTON_KEY } from '@constants/menuItemConstants';
import { HubSpotChatButton } from './HubSpotChatButton';

export function HubSpotTracker() {
  const { isAuthenticated } = useAuth();
  const { addMenuIcon } = useAppContext();
  const { pathname } = useLocation();

  useEffect(() => {
    // Check if the script is already there to prevent duplicates
    if (document.getElementById('hs-script-loader')) return;

    window.hsConversationsSettings = { loadImmediately: false };

    // Queue a callback for when HubSpot is ready so we can restore
    // the open state from session storage after the script loads.
    const onReady = () => {
      if (sessionStorage.getItem('hubspotChatOpen') === 'true') {
        const widget = window.HubSpotConversations?.widget;
        widget?.load();
        widget?.open();
      }
    };

    if (window.HubSpotConversations) {
      onReady();
    } else {
      window.hsConversationsOnReady = [...(window.hsConversationsOnReady ?? []), onReady];
    }

    const script = document.createElement('script');
    script.src = `//js.hs-scripts.com/${hubspotConfig.accountId}.js`;
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);
  }, []);

  // Refresh the widget when auth state changes so HubSpot picks up
  // the visitor's identity (or clears it on logout).
  useEffect(() => {
    const widget = window.HubSpotConversations?.widget;
    if (!widget || widget.status().loaded === false) return;
    widget.refresh(!isAuthenticated);
  }, [isAuthenticated]);

  // On route change, update HubSpot's page path and refresh the widget.
  useEffect(() => {
    window._hsq?.push(['setPath', pathname]);
    window._hsq?.push(['trackPageView']);
    const widget = window.HubSpotConversations?.widget;
    if (!widget || widget.status().loaded === false) return;
    widget.refresh();
  }, [pathname]);

  useEffect(() => {
    addMenuIcon({
      order: -1,
      key: CHAT_BUTTON_KEY,
      element: <HubSpotChatButton />,
    });
  }, [addMenuIcon]);

  return null;
}
